module.exports = __webpack_public_path__ + "static/img/07007C_1_R_20201106_fit.ee4be5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/07007C_1_R_20201106_fit.png
// module id = Y2dm
// module chunks = 0